import { FunctionComponent, useState } from 'react'
import { Line, defaults } from 'react-chartjs-2'
import { BoldText } from '../../../theme/typography'
import * as S from './styled'
import { ReactComponent as PlusSign } from '../../atoms/Icons/addPlusSign.svg'
import { ReactComponent as MinusSign } from '../../atoms/Icons/decreaseMinusSign.svg'
import { MainState } from '../../../redux/reducers'
import { useDispatch, useSelector } from 'react-redux'
import { miscActions } from '../../../redux/misc'
enum YAlign {
  TOP = 'top',
  CENTER = 'center',
  BOTTOM = 'bottom',
}

const options = {
  plugins: {
    tooltip: {
      interaction: {
        intersect: false,
        mode: 'index',
        axis: 'x',
      },
      yAlign: YAlign.CENTER,
      displayColors: false,
      usePointStyle: true,
      backgroundColor: 'rgba(255,255,255, 1)',
      borderColor: 'rgba(200,200,200, 0.5)',
      borderWidth: 2,
      titleColor: '#333B69',
      bodyFont: { weight: '600' },
      callbacks: {
        title: context => {
          const week = context[0].label
          const year = context[0].dataset.years[context[0].dataIndex]
          return `Vecka ${week} ${year}`
        },
        labelTextColor: context => {
          const color = context.dataset.borderColor
          return color
        },
      },
    },
    legend: {
      display: true,
      position: 'bottom' as any,
      labels: {
        usePointStyle: true,
        padding: 20,
      },
    },
  },
  spanGaps: false,
  scales: {
    y: {
      display: true,
      //stacked: true,
      ticks: {
        precision: 0,
        stepSize: 1,
        padding: 0,
      },
      grid: {
        borderDash: [5, 5],
        drawBorder: false,
        height: 50,
      },
    },
    x: {
      display: true,
      grid: {
        display: false,
        drawBorder: false,
      },
    },
  },
}

export type LineChartData2 = {
  label: string
  labels: { year: number; week: number }[]
  data: { year: number; week: number; value: number | null }[]
}

type OwnProps = {
  title: string
  dataSets: LineChartData2[]
  withLifeWeekSwitch?: boolean
}

type Props = OwnProps

const LineChart2: FunctionComponent<Props> = ({ dataSets, title, withLifeWeekSwitch = false }) => {
  const [modalOpen, setModalOpen] = useState(false)
  const isLifeWeek = useSelector((state: MainState) => state.misc.lifeWeek)
  const dispatch = useDispatch()
  defaults.font.family = 'Inter'
  const labels = dataSets[0].labels

  if (!labels?.length) return null
  function handleClick() {
    setModalOpen(prev => !prev)
  }
  const backgroundColors = [
    'rgb(25, 205, 86)',
    'rgb(54, 162, 235)',
    'rgb(255, 205, 86)',
    'rgb(255, 99, 132)',
    'rgb(55, 25, 86)',
  ]
  const data = dataSets.map((ds, i) => {
    return {
      label: ds.label,
      data: ds.data.map(d => d.value),
      backgroundColor: backgroundColors[i % 5],
      borderColor: backgroundColors[i % 5],
      pointBackgroundColor: backgroundColors[i % 5],
      borderWidth: 2,
      pointRadius: ds.data.length > 5 ? 1 : 4,
      years: ds.data.map(y => y.year),
    }
  })

  const lineData = {
    labels: labels.map(l => l.week),
    datasets: data,
  }
  const toggleLifeWeek = () => {
    dispatch(miscActions.toggleLifeWeek('discarded'))
  }

  return (
    <S.Chart modalOpen={modalOpen}>
      {modalOpen ? (
        <MinusSign
          style={{ position: 'absolute', top: '10px', right: '10px', width: '25px' }}
          onClick={handleClick}
        />
      ) : (
        <PlusSign
          style={{ position: 'absolute', top: '10px', right: '10px', width: '25px' }}
          onClick={handleClick}
        />
      )}
      <S.ChartHeader>
        <BoldText color={'#333B69'}>{title}</BoldText>
      </S.ChartHeader>
      <S.ChartBody>
        <Line options={options} data={lineData} />
      </S.ChartBody>
      {withLifeWeekSwitch && (
        <S.ToggleBox>
          <S.ToggleOption selected={isLifeWeek.discarded} onClick={() => toggleLifeWeek()}>
            Levnadsvecka
          </S.ToggleOption>
          <S.ToggleOption selected={!isLifeWeek.discarded} onClick={() => toggleLifeWeek()}>
            Kalendervecka
          </S.ToggleOption>
        </S.ToggleBox>
      )}
    </S.Chart>
  )
}

export default LineChart2
